import { API_CONSTANTS } from '../../services/apiConstants';
import { apiCall } from '../axios';
import { ICommodityByShipmentList } from './interface/ICommodityByShipmentList';

const fetchCommodityByShipment = async (
    shipmentId: number | string,
): Promise<ICommodityByShipmentList[]> => {
    const response = await apiCall(
        'get',
        `${API_CONSTANTS.commodity}${API_CONSTANTS.byshipment}/${shipmentId}`,
        {},
        true,
    );
    return response.data;
};

export const commodityApi = {
    fetchCommodityByShipment,
};
